export default "__VITE_ASSET__DaDj3hcb__"